import type { FunctionComponent } from 'react';
import { ContentBrick } from '../../../app-kit/components/ContentBrick/ContentBrick';
import { LinkCollection } from '../../../components/LinkCollection/LinkCollection';
import { useStreetPageQuery } from '../../graphql/useStreetPageQuery';

export const StreetPagePropertiesWithData: FunctionComponent = () => {
  const properties = useStreetPageQuery()?.data?.streetPageBySlug?.properties;
  if (!properties) return null;

  const {
    title,
    subtitle,
    items: { visible, hidden },
    showMoreButton,
  } = properties;

  return (
    <ContentBrick title={title} subtitle={subtitle}>
      <LinkCollection
        visible={visible}
        hidden={hidden}
        showMoreButtonText={showMoreButton?.title}
      />
    </ContentBrick>
  );
};
